import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'

const Navbar = () => {
    const [openMenu, setOpenMenu] = useState(false);
    const toggleMenu = () => {
      setOpenMenu(!openMenu);
    };
    const hidemenu = ()=>{
      setOpenMenu(false)
    };
  

  return (
    
    <>
    <Header className='flex'>

    <div className="logo">
        <p className="name">
        <Link to=" " className='hu'> Hulesh </Link>
            
        </p>
    </div>
    <div className="mail">
        <p className="mail">huleshjangde1@gmail.com</p>
    </div>
    <div className="menu flex">
        <Link to="/" className='desk'> Home </Link>
        <Link to="/about" className='desk'> About me </Link>
        <Link to="/project" className='desk'> Projects </Link>
        <Link to="/contact" className='desk'> Contact </Link>
        {/* <a className='desk' href="">Home</a>
        <a className='desk' href="">About me</a>
        <a className='desk' href="">Projects</a>
        <a className='desk' href="">Contact</a> */}
    </div>
    <div className="menuicon" >
        <button onClick={toggleMenu}>
            {
                !openMenu ? <img src="./images/icons/menu.png" alt="" /> : <img src="./images/icons/cut.png" alt="" />
            };
        {/* <img src="./images/icons/menu.png" alt="" /> */}
        </button>
        
    </div>
    {openMenu ? (
         <div className="mobile">
         <Link to="/" className='m' onClick={hidemenu}> Home </Link>
        <Link to="/about" className='m' onClick={hidemenu}> About me </Link>
        <Link to="/project" className='m' onClick={hidemenu}> Projects </Link>
        <Link to="/contact" className='m'  onClick={hidemenu}> Contact </Link>
         </div>
      ) : null}
   
    </Header>
    </>
  )
}
const Header = styled.section`
  .hu{
    text-decoration: none;
    color: #121629;
  }
   width :100% ;
   height: 40px;
   position: sticky;
   top: 10px;
   z-index: 10;
   justify-content: space-between;
   align-items: center;
   padding: 0 15px;
   font-weight: 300;
   background-color: #66bcf115;
   backdrop-filter: blur(25px);
   font-size: 0.8rem;
   border-radius: 20px;
   .mobile{
    background-color: #080808;
    position: absolute;
    
    top: 40px;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 25px;
    font-size: 2rem;
    width: 100%;
    height: 100vh;
    align-items: center;
    display: none;
    .m{
        text-decoration: none;
    color: #cbebf29c;
    padding: 3px 9px;
    transition: all 0.4s ease;
    font-weight: 400;
    }
    @media (max-width: 480px){
      display: block;
      display: flex;
    flex-direction: column;
    justify-content: center;
    }
   }
   .menuicon{
    display: none;
    background-color: transparent;
    border: transparent;
   img{
       /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
      width: 25px;
   
}
   
   }
    button{
        transition: all ease 2s;
        border: transparent;
        background-color: transparent;

    }
    /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
      display: block;
   
}
    @media (max-width: 480px){
      display: block;
    }
   }
   .menu{
    justify-content: space-between;
    gap: 35px;
    /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
display: none;
}
   }
   .mail{
   /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
  display: none;
}
    @media (max-width: 480px){
     display: none;
    }
   }
   .name{
    background-color: #cbebf2df;
    backdrop-filter: blur(20px);
    color: #121629;
    padding: 3px 9px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: 0.9rem;
    border-radius: 9px;
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
  backdrop-filter: none;
  font-size: 1.5rem;
}
    @media (max-width: 480px){
   backdrop-filter: none;
   }
}
   p{
    color: #cbebf29c;
   }
   .desk{
    text-decoration: none;
    color: #cbebf29c;
    padding: 3px 9px;
    transition: all 0.4s ease;
    font-weight: 400;
    @media (max-width: 480px){
     display: none;
    }
    
    :hover{
        background-color:#e1e1e1bb ;
        color: #121629;
        padding: 3px 9px;
        font-weight: 400;
    }
   }


`

export default Navbar